const stations = [
    {
        title: 'تهران',
        code: 1,
        latitude: 3.5658142e1,
        longitude: 5.1398014e1,
        enTitle: 'tehran',
    },
    {
        title: 'آبگرم',
        code: 4,
        latitude: 3.5757969e1,
        longitude: 4.9286438e1,
        enTitle: 'abgram',
    },
    {
        title: 'آبیک',
        code: 7,
        latitude: 3.6032543e1,
        longitude: 5.0514206e1,
        enTitle: 'abeyk',
    },
    { title: 'آتش بغ', code: 9, enTitle: 'atashbag' },
    {
        title: 'اراک',
        code: 14,
        latitude: 3.407214e1,
        longitude: 4.970055e1,
        enTitle: 'arak',
    },
    {
        title: 'اردبیل',
        code: 452,
        latitude: 3.82498e1,
        longitude: 4.82933e1,
        enTitle: 'ardebil',
    },
    {
        title: 'ملایر',
        code: 15,
        latitude: 3.4247162e1,
        longitude: 4.884948e1,
        enTitle: 'malayer',
    },
    {
        title: 'ازنا',
        code: 18,
        latitude: 3.3454556e1,
        longitude: 4.9450733e1,
        enTitle: 'azna',
    },
    {
        title: 'اصفهان',
        code: 21,
        latitude: 3.2549763e1,
        longitude: 5.1694912e1,
        enTitle: 'isfahan',
    },
    {
        title: 'اندیمشک',
        code: 24,
        latitude: 3.245557e1,
        longitude: 4.8351662e1,
        enTitle: 'andimeshk',
    },
    {
        title: 'اهواز',
        code: 25,
        latitude: 3.1324551e1,
        longitude: 4.8664139e1,
        enTitle: 'ahvaz',
    },
    {
        title: 'بادرود',
        code: 28,
        latitude: 3.3656689e1,
        longitude: 5.2032082e1,
        enTitle: 'badroud',
    },
    {
        title: 'بافق',
        code: 30,
        latitude: 3.1587816e1,
        longitude: 5.5398846e1,
        enTitle: 'bafgh',
    },
    {
        title: 'بندرترکمن',
        code: 36,
        latitude: 3.6893257e1,
        longitude: 5.4066006e1,
        enTitle: 'bandar_torkaman',
    },
    {
        title: 'بندرعباس',
        code: 37,
        latitude: 2.72118e1,
        longitude: 5.625729e1,
        enTitle: 'bandar_abbas',
    },
    {
        title: 'بیشه',
        code: 44,
        latitude: 3.3330105e1,
        longitude: 4.8876221e1,
        enTitle: 'bisheh',
    },
    {
        title: 'پل سفید',
        code: 50,
        latitude: 3.611499e1,
        longitude: 5.3056557e1,
        enTitle: 'pol_sefid',
    },
    {
        title: 'الوند',
        code: 51,
        latitude: 3.6186001e1,
        longitude: 5.0064983e1,
        enTitle: 'alvand',
    },
    {
        title: 'پیشوا',
        code: 53,
        latitude: 3.5308636e1,
        longitude: 5.1734119e1,
        enTitle: 'pishva',
    },
    {
        title: 'تاکستان',
        code: 54,
        latitude: 3.6071934e1,
        longitude: 4.9703236e1,
        enTitle: 'takestan',
    },
    {
        title: 'تبریز',
        code: 55,
        latitude: 3.8071796e1,
        longitude: 4.6228615e1,
        enTitle: 'tabriz',
    },
    {
        title: 'تپه سفید',
        code: 56,
        latitude: 4.390015e1,
        longitude: 7.9444633e1,
        enTitle: 'tape_sefid',
    },
    { title: 'تنگ هفت', code: 59, enTitle: 'tang_e_haft' },
    {
        title: 'جاجرم',
        code: 61,
        latitude: 3.6703384e1,
        longitude: 5.6527843e1,
        enTitle: 'jajarm',
    },
    {
        title: 'جوین',
        code: 62,
        latitude: 3.6725731e1,
        longitude: 5.7175682e1,
        enTitle: 'joen',
    },
    {
        title: 'ساوه',
        code: 65,
        latitude: 3.5106255e1,
        longitude: 5.0269852e1,
        enTitle: 'saveh',
    },
    {
        title: 'چمسنگر',
        code: 66,
        latitude: 3.316441e1,
        longitude: 4.8761196e1,
        enTitle: 'chamsangar',
    },
    {
        title: 'خراسانک',
        code: 69,
        latitude: 3.7381687e1,
        longitude: 4.7113445e1,
        enTitle: 'khorasanak',
    },
    { title: 'خرم پی', code: 70, enTitle: 'khoram_pey' },
    {
        title: 'خرم دره',
        code: 71,
        latitude: 3.6186291e1,
        longitude: 4.9239643e1,
        enTitle: 'khorramdarreh',
    },
    {
        title: 'خرمشهر',
        code: 72,
        latitude: 3.0447378e1,
        longitude: 4.8163082e1,
        enTitle: 'khorramshahr',
    },
    {
        title: 'دامغان',
        code: 75,
        latitude: 3.6150909e1,
        longitude: 5.4370163e1,
        enTitle: 'damghan',
    },
    {
        title: 'دورود',
        code: 78,
        latitude: 3.3484417e1,
        longitude: 4.9063957e1,
        enTitle: 'dorud',
    },
    {
        title: 'زرند',
        code: 92,
        latitude: 3.0812513e1,
        longitude: 5.6582233e1,
        enTitle: 'zarand',
    },
    {
        title: 'زرین دشت',
        code: 96,
        latitude: 2.8354506e1,
        longitude: 5.4417801e1,
        enTitle: 'zarrindasht',
    },
    {
        title: 'زنجان',
        code: 97,
        latitude: 3.6661224e1,
        longitude: 4.8481548e1,
        enTitle: 'zanjan',
    },
    {
        title: 'ساری',
        code: 100,
        latitude: 3.6552902e1,
        longitude: 5.305872e1,
        enTitle: 'sari',
    },
    {
        title: 'سبزوار',
        code: 105,
        latitude: 3.6215183e1,
        longitude: 5.7667824e1,
        enTitle: 'sabzevar',
    },
    {
        title: 'سپیددشت',
        code: 106,
        latitude: 3.3217285e1,
        longitude: 4.8884403e1,
        enTitle: 'sepid_dasht',
    },
    {
        title: 'سلماس',
        code: 115,
        latitude: 3.8330135e1,
        longitude: 4.4826786e1,
        enTitle: 'salmas',
    },
    {
        title: 'سمنان',
        code: 116,
        latitude: 3.5552658e1,
        longitude: 5.340461e1,
        enTitle: 'semnan',
    },
    {
        title: 'همدان',
        code: 117,
        latitude: 3.486924e1,
        longitude: 4.8619305e1,
        enTitle: 'hamedan',
    },
    {
        title: 'سوادکوه',
        code: 121,
        latitude: 3.6148682e1,
        longitude: 5.3026966e1,
        enTitle: 'savadkuh',
    },
    {
        title: 'سهند',
        code: 123,
        latitude: 3.5658142e1,
        longitude: 5.1398014e1,
        enTitle: 'sahand',
    },
    {
        title: 'سیرجان',
        code: 125,
        latitude: 2.9508343e1,
        longitude: 5.564893e1,
        enTitle: 'sirjan',
    },
    {
        title: 'سیمین دشت',
        code: 128,
        latitude: 3.5520706e1,
        longitude: 5.250116e1,
        enTitle: 'simindasht',
    },
    {
        title: 'شازند',
        code: 129,
        latitude: 3.3941231e1,
        longitude: 4.9418327e1,
        enTitle: 'shazand',
    },
    {
        title: 'شاهرود',
        code: 130,
        latitude: 3.6400379e1,
        longitude: 5.5001461e1,
        enTitle: 'shahroud',
    },
    {
        title: 'شرفخانه',
        code: 133,
        latitude: 3.8168468e1,
        longitude: 4.5484596e1,
        enTitle: 'sharafkhaneh',
    },
    {
        title: 'شوشتر',
        code: 134,
        latitude: 3.2052448e1,
        longitude: 4.8830151e1,
        enTitle: 'shooshtar',
    },
    {
        title: 'شوش',
        code: 135,
        latitude: 3.2205044e1,
        longitude: 4.8289837e1,
        enTitle: 'shush',
    },
    {
        title: 'خاوران (تبریز)',
        code: 143,
        latitude: 3.8003601e1,
        longitude: 4.6413502e1,
        enTitle: 'khavaran',
    },
    {
        title: 'شیرگاه',
        code: 144,
        latitude: 3.6294163e1,
        longitude: 5.2888176e1,
        enTitle: 'shirgah',
    },
    {
        title: 'عجب شیر',
        code: 148,
        latitude: 3.7501842e1,
        longitude: 4.5882011e1,
        enTitle: 'ajabshir',
    },
    {
        title: 'فیروزکوه',
        code: 154,
        latitude: 3.5749916e1,
        longitude: 5.2774921e1,
        enTitle: 'firuzkuh',
    },
    {
        title: 'قائمشهر',
        code: 156,
        latitude: 3.646294e1,
        longitude: 5.2862686e1,
        enTitle: 'qaemshahr',
    },
    {
        title: 'قزوین',
        code: 160,
        latitude: 3.6242485e1,
        longitude: 5.0005707e1,
        enTitle: 'qazvin',
    },
    {
        title: 'قم',
        code: 161,
        latitude: 3.4648354e1,
        longitude: 5.0873199e1,
        enTitle: 'qom',
    },
    {
        title: 'کاشان',
        code: 162,
        latitude: 3.3987183e1,
        longitude: 5.1471516e1,
        enTitle: 'kashan',
    },
    {
        title: 'کرج',
        code: 165,
        latitude: 3.5779728e1,
        longitude: 5.0989433e1,
        enTitle: 'karaj',
    },
    {
        title: 'کرمان',
        code: 167,
        latitude: 3.0245409e1,
        longitude: 5.7024017e1,
        enTitle: 'kerman',
    },
    {
        title: 'گرگان',
        code: 175,
        latitude: 3.6855637e1,
        longitude: 5.442062e1,
        enTitle: 'gorgan',
    },
    {
        title: 'گرمسار',
        code: 176,
        latitude: 3.5234589e1,
        longitude: 5.2306473e1,
        enTitle: 'garmsar',
    },
    {
        title: 'مراغه',
        code: 189,
        latitude: 3.7379856e1,
        longitude: 4.6234287e1,
        enTitle: 'maragheh',
    },
    {
        title: 'مشهد',
        code: 191,
        latitude: 3.6304375e1,
        longitude: 5.9624203e1,
        enTitle: 'mashhad',
    },
    {
        title: 'مهاباد',
        code: 194,
        latitude: 3.6899235e1,
        longitude: 4.572139e1,
        enTitle: 'mahabad',
    },
    {
        title: 'کرمانشاه',
        code: 195,
        latitude: 3.4338428e1,
        longitude: 4.7131947e1,
        enTitle: 'kermanshah',
    },
    {
        title: 'میانه',
        code: 197,
        latitude: 3.7382957e1,
        longitude: 4.7739189e1,
        enTitle: 'mianeh',
    },
    {
        title: 'میبد',
        code: 198,
        latitude: 3.2230545e1,
        longitude: 5.3928665e1,
        enTitle: 'meybod',
    },
    {
        title: 'نقاب',
        code: 202,
        latitude: 3.6657627e1,
        longitude: 5.7420471e1,
        enTitle: 'neghab',
    },
    {
        title: 'نکا',
        code: 203,
        latitude: 3.6656189e1,
        longitude: 5.3289604e1,
        enTitle: 'neka',
    },
    {
        title: 'نیشابور',
        code: 206,
        latitude: 3.6195007e1,
        longitude: 5.8785099e1,
        enTitle: 'neyshabur',
    },
    {
        title: 'ورامین',
        code: 209,
        latitude: 3.5335392e1,
        longitude: 5.1644081e1,
        enTitle: 'varamin',
    },
    {
        title: 'ورسک',
        code: 212,
        latitude: 3.5903194e1,
        longitude: 5.2990719e1,
        enTitle: 'veresk',
    },
    {
        title: 'هشتگرد',
        code: 215,
        latitude: 3.5949711e1,
        longitude: 5.0669243e1,
        enTitle: 'hashtgerd',
    },
    {
        title: 'هفت تپه',
        code: 216,
        latitude: 3.2073708e1,
        longitude: 4.8337967e1,
        enTitle: 'hafttapeh',
    },
    {
        title: 'یزد',
        code: 219,
        latitude: 3.186471e1,
        longitude: 5.4344727e1,
        enTitle: 'yazd',
    },
    {
        title: 'جلفا',
        code: 221,
        latitude: 3.8937855e1,
        longitude: 4.5630398e1,
        enTitle: 'jolfa',
    },
    {
        title: 'آزادور',
        code: 224,
        latitude: 3.674506e1,
        longitude: 5.6720146e1,
        enTitle: 'azadvar',
    },
    {
        title: 'بهاباد',
        code: 226,
        latitude: 3.1871595e1,
        longitude: 5.6019424e1,
        enTitle: 'bahabad',
    },
    {
        title: 'سرخس',
        code: 234,
        latitude: 3.6544891e1,
        longitude: 6.115197e1,
        enTitle: 'sarakhs',
    },
    {
        title: 'زواره',
        code: 239,
        latitude: 3.3433022e1,
        longitude: 5.2510105e1,
        enTitle: 'zavareh',
    },
    {
        title: 'محمدیه',
        code: 249,
        latitude: 3.4558983e1,
        longitude: 5.1048264e1,
        enTitle: 'mohammadieh',
    },
    {
        title: 'میاندوآب',
        code: 250,
        latitude: 3.7008503e1,
        longitude: 4.6055054e1,
        enTitle: 'qoshachay',
    },
    {
        title: 'تربت حیدریه',
        code: 251,
        latitude: 3.5273926e1,
        longitude: 5.9306751e1,
        enTitle: 'torbat_heydariyeh',
    },
    {
        title: 'شیراز',
        code: 255,
        latitude: 2.9764133e1,
        longitude: 5.2431404e1,
        enTitle: 'shiraz',
    },
    {
        title: 'مرودشت',
        code: 256,
        latitude: 2.9896646e1,
        longitude: 5.2801785e1,
        enTitle: 'marvdasht',
    },
    {
        title: 'سعادت شهر',
        code: 257,
        latitude: 3.0105053e1,
        longitude: 5.3093937e1,
        enTitle: 'saadat_shahr',
    },
    {
        title: 'صفاشهر',
        code: 258,
        latitude: 3.0585035e1,
        longitude: 5.3194614e1,
        enTitle: 'safashahr',
    },
    {
        title: 'زاهدان',
        code: 259,
        latitude: 2.9479992e1,
        longitude: 6.0874928e1,
        enTitle: 'zahedan',
    },
    {
        title: 'اردکان',
        code: 261,
        latitude: 3.2350601e1,
        longitude: 5.3898262e1,
        enTitle: 'ardakan',
    },
    {
        title: 'شهرضا',
        code: 264,
        latitude: 3.1976038e1,
        longitude: 5.1832218e1,
        enTitle: 'shahreza',
    },
    {
        title: 'رازی',
        code: 285,
        latitude: 3.8492825e1,
        longitude: 4.434417e1,
        enTitle: 'razi',
    },
    {
        title: 'آنکارا',
        code: 290,
        latitude: 3.9934906e1,
        longitude: 3.2843521e1,
        enTitle: 'ankara',
    },
    {
        title: 'وان',
        code: 295,
        latitude: 3.8521908e1,
        longitude: 4.3382813e1,
        enTitle: 'van',
    },
    {
        title: 'بم',
        code: 299,
        latitude: 2.9033421e1,
        longitude: 5.8352261e1,
        enTitle: 'bam',
    },
    {
        title: 'اسلامشهر',
        code: 301,
        latitude: 3.5554028e1,
        longitude: 5.1214928e1,
        enTitle: 'eslamshahr',
    },
    {
        title: 'ماهشهر',
        code: 302,
        latitude: 3.0560225e1,
        longitude: 4.9171658e1,
        enTitle: 'bandar_mahshahr',
    },
    {
        title: 'طبس',
        code: 311,
        latitude: 3.3619301e1,
        longitude: 5.6888046e1,
        enTitle: 'tabas',
    },
    {
        title: 'آباده',
        code: 337,
        latitude: 3.1170307e1,
        longitude: 5.2580933e1,
        enTitle: 'abadeh',
    },
    {
        title: 'جمکران',
        code: 351,
        latitude: 3.4597145e1,
        longitude: 5.0918026e1,
        enTitle: 'jamkaran',
    },
    {
        title: 'خواف',
        code: 369,
        latitude: 3.4567165e1,
        longitude: 6.0185989e1,
        enTitle: 'khaf',
    },
    {
        title: 'زادمحمود',
        code: 373,
        latitude: 2.756423e1,
        longitude: 5.5195709e1,
        enTitle: 'zahed_mahmud',
    },
    {
        title: 'بجستان',
        code: 383,
        latitude: 3.4522057e1,
        longitude: 5.8172207e1,
        enTitle: 'bajestan',
    },
    {
        title: 'اقلید',
        code: 387,
        latitude: 3.1006536e1,
        longitude: 5.275021e1,
        enTitle: 'eqlid',
    },
    {
        title: 'پرند',
        code: 401,
        latitude: 3.5464188e1,
        longitude: 5.0977943e1,
        enTitle: 'parand',
    },
    { title: 'کارون', code: 403, enTitle: 'karun' },
    {
        title: 'ارومیه',
        code: 448,
        latitude: 3.7564327e1,
        longitude: 4.5097466e1,
        enTitle: 'urmia',
    },
    {
        title: 'رشت',
        code: 451,
        latitude: 3.7207645e1,
        longitude: 4.955891e1,
        enTitle: 'rasht',
    },
    {
        title: 'نخجوان',
        code: 507,
        latitude: 3.932568e1,
        longitude: 4.5491264e1,
        enTitle: 'nakhchivan',
    },
    {
        title: 'کربلا',
        code: 512,
        latitude: 3.6031933e1,
        longitude: 5.0534222e1,
        enTitle: 'karbala',
    },
    {
        title: 'فهرج',
        code: 509,
        latitude: 2.8944468e1,
        longitude: 5.8883381e1,
        enTitle: 'fahraj',
    },
    {
        title: 'ارسنجان',
        code: 510,
        latitude: 2.9919685e1,
        longitude: 5.3298885e1,
        enTitle: 'arsenjan',
    },
    {
        title: 'خاش',
        code: 513,
        latitude: 2.8204979e1,
        longitude: 6.1191086e1,
        enTitle: 'khash',
    },
    { title: 'تربیت معلم', code: 912, enTitle: 'tarbiat_moalem' },
    { title: 'سنندج', code: 300, enTitle: 'sanandaj' },
    {
        title: 'نایین',
        code: 225,
        latitude: 32.86,
        longitude: 53.0875,
        enTitle: 'nain',
    },
    {
        title: 'مهریز',
        code: 500266,
        latitude: 31.5440178,
        longitude: 54.5735931,
        enTitle: 'mehriz',
    },
];

export default stations.map(l => ({
    ...l,
    code: l.enTitle,
    stationId: l.code,
}));
